import NewsFeedSlider from './newsFeed/NewsFeedSlider';
import { useQuery } from '@tanstack/react-query';
import { getNewsfeed } from 'src/services/account';

const DashboardNewsFeed = () => {
  const { data, isFetching } = useQuery({
    queryKey: ['dashboard-newsFeed'],
    queryFn: async () => {
      const res = await getNewsfeed();

      return res.data;
    },
    refetchOnWindowFocus: false
  });

  const showTimer = () => {
    if (!data) return false;

    return (data?.newsArticles?.length ?? 0) > 1
  };

  return <NewsFeedSlider loading={isFetching} newsFeed={data?.newsArticles} showTimer={showTimer()} slideDuration={15} />;
};

export default DashboardNewsFeed;
